module.exports = __webpack_public_path__ + "static/logo_horizontal_metodologiaead-9142439530312c09f08c3b5de6dbfadd.png";